import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import ReactCountryFlag from 'react-country-flag';
import cx from 'classnames';
import styles from './CountryFlag.module.scss';
const CountryFlag = ({ code, label, className }) => (_jsxs("div", { className: cx(styles.countryFlag, className), children: [_jsx(ReactCountryFlag, { style: {
                width: '24px',
                height: '24px',
            }, className: styles.flag, countryCode: code, svg: true }), label && _jsx("span", { className: styles.label, children: label })] }));
export default Object.assign(memo(CountryFlag), { displayName: 'CountryFlag' });
